/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { invoiceService } from "../../../Services/invoice.service";
import { globalServices } from "../../../Services/global.service";
import { userServices } from "../../../Services/user.service";
import { storeService } from "../../../Services/store.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import { Modal } from "react-bootstrap";
import Tooltip from "../../../Components/Common/Tooltip";
import DatePicker, { registerLocale } from "react-datepicker";
import * as dateHelper from "../../../Helpers/DateHelper";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { invoiceIssuedReportServices } from "../../../Services/PDFservice/invoicesissuedreport.service";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import moment from "moment";
import AsyncSelect from "react-select/async";
import XLSX from "xlsx";
import { convertToPdf } from "../../../Services/PDFservice/invoiceToPdf.service";
import QRCode from "qrcode.react";
import {
  convertToDecimalString,
  convertToDecimalForPoreznaString,
} from "../../../Helpers/DecimalNumberHelper";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
import { roles } from "../../../Config/Roles";
import Loading from "react-fullscreen-loading";
import { serialize } from "object-to-formdata";
import EmailModal from "./EmailModal";
import EdiFiscalModal from "./EdiFiscalModal";
import ResultModal from "../../Common/ResultModal";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;
registerLocale("hr", hr);
registerLocale("en", en);

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  const [qrCodeGen, setQrCodeGen] = useState("");
  const [sendPdfToMailOpenModal, setSendPdfToMailOpenModal] = useState(false);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const { userId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [bigLoading, setBigLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [posTag, setPosTag] = useState([]);
  const [tenantPartners, setTenantPartners] = useState([]);
  const [users, setUsers] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [invoiceDetailsItems, setInvoiceDetailsItems] = useState([]);
  const [invoiceDetailsTaxes, setInvoiceDetailsTaxes] = useState([]);
  const [invoiceDetailsPayments, setInvoiceDetailsPayments] = useState([]);
  const [qrcodeText, setQRcodeText] = useState("");
  const [paymentId, setPaymentId] = useState();
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [showEdiFiscalModal, setShowEdiFiscalModal] = useState(false);
  const [ediFiscalResultModal, setEdiFiscalResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    storeTag: "",
    posTag: "",
    fromIssuedTime: "",
    toIssuedTime: "",
    partnerGuid: "",
    userGuid: "",
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    partnerName: "",
    userName: "",
    dateFrom: "",
    dateTo: "",
  });
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [update, setUpdate] = useState(new Date());
  const [year] = useState(new Date());

  useEffect(() => {
    updateLocName("invoices-issued-report");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  useEffect(() => {
    if (reportTag.dateFrom != "") {
      handleToSearch();
    }
  }, [update]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPartners = (tenant) => {
    globalServices
      .getPartnersByTenantId(tenant)
      .then((res) => {
        setTenantPartners(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getUsers = (id, type) => {
    if (type == 1) {
      let url = `tenant/${id}/users`;
      userServices
        .getUsersByTenant(url)
        .then((res) => {
          setUsers(res.data.data);
        })
        .catch((err) => console.log(err));
    } else {
      let url = `store/${id}/users`;
      userServices
        .getUsersByTenant(url)
        .then((res) => {
          setUsers(res.data.data);
        })
        .catch((err) => console.log(err));
    }
  };

  const getDetails = (invoiceGuid) => {
    reportService
      .invoiceDetail(invoiceGuid)
      .then((res) => {
        console.log("r", res.data.data);
        setInvoiceDetails(res.data.data);
        setInvoiceDetailsItems(res.data.items);
        setInvoiceDetailsTaxes(res.data.taxes);
        setInvoiceDetailsPayments(res.data.payments);
        setPaymentId(res.data.payments[0].paymentMethodId);

        var iznos = convertToDecimalForPoreznaString(res.data.data.payValue);
        console.log("iznos", iznos);
        setQRcodeText(
          `https://porezna.gov.hr/rn?jir=${res.data.data.jir}&datv=${new Date(
            res.data.data.issued
          )
            .toISOString()
            .replace("-", "")
            .split("T")[0]
            .replace("-", "")}_${new Date(res.data.data.issued)
            .getHours()
            .toString()
            .padStart(2, "0")}${new Date(res.data.data.issued)
            .getMinutes()
            .toString()
            .padStart(2, "0")}&izn=${iznos.replace(".", "")}`
        );
      })
      .catch((err) => console.log(err));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };
  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);
    var m = moment();
    var date = moment(search.validTo);
    m.set(date.toObject());
    reportService
      .invoicesView({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        storeTag: search.storeTag,
        posTag: search.posTag,
        partnerGuid: search.partnerGuid,
        userGuid: search.userGuid,
        fromIssuedTime: search.validFrom,
        toIssuedTime: m.endOf("day").format(),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setReports(res.data.data);
        setPagination({
          ...pagination,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setShowInvoiceDetails(true);
      getDetails(row.invoiceGuid);
    },
  };

  const rowClasses = (row, rowIndex) => {
    if (row.payValue === 0) {
      return "text-danger";
    } else {
      return "boostrap-table-row";
    }
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses={rowClasses}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell, row) {
    console.log(cell);
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(row?.issued),
    }).format(Number(cell));
  }

  function documentNumberFormatter(cell, row) {
    return `${cell}/${row.storeTag}/${row.posTag}`;
  }
  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  function dateFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }

  function fiscalFormatter(cell, row) {
    return cell ? "Da" : "Ne" + "(" + row.errDescription + ")"; //${cell *}/${row.storeTag}/${row.posTag}`;
  }

  const columns = [
    {
      dataField: "documentNumber",
      text: translator("Report-View-TableHeader-DocumentNumber"),

      formatter: documentNumberFormatter,
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
        };
      },
      style: (colum, colIndex) => {
        return {
          width: "150px",
        };
      },
    },
    {
      dataField: "issued",
      text: translator("Report-View-TableHeader-Issued"),
      formatter: dateTimeFormatter,

      headerStyle: (colum, colIndex) => {
        return {
          width: "250px",
        };
      },
      style: (colum, colIndex) => {
        return {
          width: "250px",
        };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "createdByPrintName",
      text: translator("Report-View-TableHeader-CreatedByPrintName"),
      hidden: Boolean(isMobile),
      headerStyle: () => {
        return { width: "200px", textAlign: "right" };
      },
      style: () => {
        return { width: "200px", textAlign: "right" };
      },
    },
    {
      dataField: "payValue",
      text: translator("Report-View-TableHeader-PayValue"),
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "jir",
      text: translator("Report-View-TableHeader-Fiscal"),
      hidden: Boolean(isMobile),
      formatter: fiscalFormatter,
    },
  ];

  const fixInvoice = (guid) => {
    reportService
      .fixInvoice(guid)
      .then((res) => {
        alert(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportToPdf = () => {
    let base64QR = document.getElementById("qrCode")?.toDataURL();
    convertToPdf.handlePrint(
      invoiceDetails,
      invoiceDetailsItems,
      invoiceDetailsPayments,
      invoiceDetailsTaxes,
      translator,
      base64QR
    );
  };

  const sendPdfToPartnerMail = async () => {
    let base64QR = document.getElementById("qrCode")?.toDataURL();
    var data = await convertToPdf.sendPdfToPartnerMail(
      invoiceDetails,
      invoiceDetailsItems,
      invoiceDetailsPayments,
      invoiceDetailsTaxes,
      translator,
      base64QR
    );
    console.log(data);
  };

  const openSendMailModal = async () => {
    let base64QR = document.getElementById("qrCode")?.toDataURL();
    setQrCodeGen(base64QR);
    setSendPdfToMailOpenModal(true);
    
  };

  const fiscal = (guid) => {
    invoiceService
      .fiscal(guid)
      .then((res) => {
        res?.data === true
          ? setEdiFiscalResultModal({
              show: true,
              title: translator("EdiFiscalModal-SuccessModal-Title"),
              text: translator("EdiFiscalModal-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setEdiFiscalResultModal({
              show: true,
              title: translator("EdiFiscalModal-UnsuccessModal-Title"),
              text: translator("EdiFiscalModal-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => {
        console.error(err.response);
        setEdiFiscalResultModal({
          show: true,
          title: translator("EdiFiscalModal-UnsuccessModal-Title"),
          text: translator("EdiFiscalModal-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        });
      });
  };

  const ediFiscal = (guid) => {
    setShowEdiFiscalModal(false);
    invoiceService
      .ediFiscal(guid)
      .then((res) => {
        res?.data?.success
          ? setEdiFiscalResultModal({
              show: true,
              title: translator("EdiFiscalModal-SuccessModal-Title"),
              text: translator("EdiFiscalModal-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setEdiFiscalResultModal({
              show: true,
              title: translator("EdiFiscalModal-UnsuccessModal-Title"),
              text: translator("EdiFiscalModal-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => {
        console.error(err.response);
        setEdiFiscalResultModal({
          show: true,
          title: translator("EdiFiscalModal-UnsuccessModal-Title"),
          text: translator("EdiFiscalModal-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        });
      });
  };

  const exportFunction = () => {
    var m = moment();
    var date = moment(search.validTo);
    m.set(date.toObject());
    reportService
      .invoicesView({
        tenantId: Number(search.tenantId),
        storeTag: search.storeTag,
        posTag: search.posTag,
        fromIssuedTime: search.validFrom,
        toIssuedTime: m.endOf("day").format(),
        pageIndex: search.pageIndex,
        pageSize: 0,
        partnerGuid: search.partnerGuid,
      })
      .then((res) => {
        invoiceIssuedReportServices.handlePrint(
          res.data.data,
          reportTag,
          translator
        );
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportExcelFunction = () => {
    var m = moment();
    var date = moment(search.validTo);
    m.set(date.toObject());
    reportService
      .invoicesView({
        tenantId: Number(search.tenantId),
        storeTag: search.storeTag,
        posTag: search.posTag,
        fromIssuedTime: search.validFrom,
        toIssuedTime: m.endOf("day").format(),
        pageIndex: search.pageIndex,
        pageSize: 0,
        partnerGuid: search.partnerGuid,
      })
      .then((res) => {
        var totalSum = res.data.data.reduce(
          (sum, item) => sum + item.payValue,
          0
        );
        console.log("sum", totalSum);
        // File name
        var ws_name = `${translator(
          "InvoiceConclCashBalancePDF-ReportOverview"
        )}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
          [
            translator("InvoiceCashBalancePDF-Date"),
            reportTag.dateFrom,
            reportTag.dateTo,
          ],
          [translator("Ukupno"), totalSum],
          [
            translator("Report-View-TableHeader-DocumentNumber"),
            translator("InitialState-Store"),
            translator("InvIssReport-Filters-PosTag"),
            translator("Report-View-TableHeader-Issued"),
            "ZKI",
            "JIR",
            translator("Report-View-TableHeader-PayValue"),
            translator("Report-View-TableHeader-CreatedByPrintName"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res.data.data.map((x) => {
          const array = [
            documentNumberFormatter(x.documentNumber, x),
            x.storeTag,
            x.posTag,
            dateTimeFormatter(x.issued),
            x.zki,
            x.jir,
            x.payValue,
            x.createdByPrintName,
          ];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [
          { width: 12 },
          { width: 16 },
          { width: 15 },
          { width: 23 },
          { width: 37 },
          { width: 37 },
          { width: 13 },
          { width: 13 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, ws_name);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportOverviewTotalExcelFunction = () => {
    setBigLoading(true);
    var m = moment();
    var date = moment(search.validTo);
    m.set(date.toObject());
    Promise.all([
      reportService.totalOverview(
        Number(search.tenantId),
        search.storeTag,
        search.posTag,
        search.partnerGuid,
        search.validFrom,
        m.startOf("day").format()
      ),
      reportService.totalOverviewItems(
        Number(search.tenantId),
        search.storeTag,
        search.posTag,
        search.partnerGuid,
        search.validFrom,
        m.startOf("day").format()
      ),
    ])
      .then((res) => {
        // File name
        var ws_name = `${translator("OverviewTotal")}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        // Constant Data
        var ws_data = [
          [
            translator("R.br."),
            translator("Broj računa"),
            translator("Datum izadavanja"),
            translator("Partner"),
            translator("Blagajnik"),
            translator("Način plaćanja"),
            translator("PDV 25 - Osnovica"),
            translator("PDV 25"),
            translator("PDV 13 - Osnovica"),
            translator("PDV 13"),
            translator("PDV 5 - Osnovica"),
            translator("PDV 5"),
            translator("Iznos računa"),
            translator("Popust"),
            translator("Napomena"),
            translator("Status fiskalizacije"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res[0].data.data.map((x) => {
          const array = [
            x.rowNumber,
            x.invoiceNumber,
            dateTimeFormatter(x.issued),
            x.partnerName,
            x.operatorPrintName,
            x.paymentMethodNames,
            x.totalNetValue_25Perc,
            x.totalTax_25Perc,
            x.totalNetValue_13Perc,
            x.totalTax_13Perc,
            x.totalNetValue_5Perc,
            x.totalTax_5Perc,
            x.totalPayValue,
            x.totalDiscountValue,
            x.isStorno ? "Storno" : "",
            x.isFiscalized ? "Provedena" : "Nije provedena",
          ];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        let ws_data2 = [
          [
            translator("Datum prodaje"),
            translator("Vrijeme prodaje"),
            translator("Datum ulaska u bazu"),
            translator("Blagajnik ime"),
            translator("Blagajnik oib"),
            translator("Prodajno mjesto šifra"),
            translator("Prodajno mjesto naziv"),
            translator("Oznaka naplatnog uređaja"),
            translator("Broj računa"),
            translator("Način plaćanja"),
            translator("Artikl šifra"),
            translator("Artikl opis"),
            translator("Količina"),
            translator("Jed cijena"),
            translator("Iznos"),
            translator("Popust post"),
            translator("Popust"),
            translator("Jedinična osnovica za PDV"),
            translator("Ukupna osnovica za PDV"),
            translator("Stopa PDV-a"),
            translator("ZKI"),
            translator("JIR"),
            translator("Iznos PDV-a"),
            translator("Stopa PNP-a"),
            translator("Iznos PNP-a"),
            translator("Iznos PN-a"),
            translator("Iznos osnovice"),
            translator("Iznos poreza"),
          ],
        ];
        let ws_sufix2 = res[1].data.data.map((x) => {
          const array = [
            dateFormatter(x.issuedDate),
            x.issuedTime,
            dateFormatter(x.issuedDate) + "" + x.issuedTime,
            x.operatorPrintName,
            x.operatorPersonalIdentificationNumber,
            x.storeTag,
            x.storeName,
            x.posTag,
            x.invoiceNumber,
            x.paymentMethodNames,
            x.productCode,
            x.productName,
            x.quantity,
            x.price,
            x.price * x.quantity,
            x.discount,
            x.discountValue,
            x.unitNetPrice,
            x.totalNetPrice,
            x.taxPercentage,
            x.zki,
            x.jir,
            x.taxValue,
            x.pnpPercentage,
            x.pnpValue,
            x.pnValue,
            (x.price * x.quantity) / (1 + x.taxPercentage / 100),
            x.price * x.quantity -
              (x.price * x.quantity) / (1 + x.taxPercentage / 100),
          ];
          return array;
        });
        ws_data2 = [...ws_data2, ...ws_sufix2];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        const ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
        ws["!cols"] = [
          { width: 5 },
          { width: 15 },
          { width: 25 },
          { width: 25 },
          { width: 25 },
          { width: 30 },
          { width: 20 },
          { width: 15 },
          { width: 20 },
          { width: 15 },
          { width: 15 },
          { width: 15 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 22 },
        ];
        ws2["!cols"] = [
          { width: 25 },
          { width: 15 },
          { width: 25 },
          { width: 25 },
          { width: 25 },
          { width: 25 },
          { width: 20 },
          { width: 30 },
          { width: 20 },
          { width: 30 },
          { width: 10 },
          { width: 15 },
          { width: 15 },
          { width: 15 },
          { width: 20 },
          { width: 25 },
          { width: 25 },
          { width: 22 },
          { width: 35 },
          { width: 35 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, "Totali");
        XLSX.utils.book_append_sheet(wb, ws2, "Stavke");
        XLSX.writeFile(wb, ws_name);

        setBigLoading(false);
      })
      .catch((err) => {
        setBigLoading(false);
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <Loading
          loading={bigLoading}
          background="rgba(60, 60, 60, 0.5)"
          loaderColor={process.env.REACT_APP_COLOR}
        />
        <div className="card-header card-wrap">
          <span>{translator("InvIssReport-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeTag", null);
                        setValue("posTag", null);
                        setValue("partners", null);
                        setValue("users", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                          storeTag: "",
                          posTag: "",
                          partnerGuid: "",
                          userGuid: "",
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });
                        getStores(event[0].id);
                        getPartners(event[0].id);
                        getUsers(event[0].id, 1);
                        //setReports([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                    <Tooltip text={translator("StoreTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      name="storeTag"
                      placeholder={translator("SelectStoreTag")}
                      onChange={function (event) {
                        setValue("posTag", null);
                        setValue("partners", null);
                        setValue("users", null);
                        setSearch({
                          ...search,
                          storeTag: event[0].value,
                          posTag: "",
                          partnerGuid: "",
                          userGuid: "",
                        });
                        setReportTag({
                          ...reportTag,
                          storeName: event[0].label,
                        });
                        getPos(event[0].id);
                        getUsers(event[0].id, 2);
                        //setReports([]);

                        return event[0];
                      }}
                      options={
                        storesTag &&
                        storesTag.map((e) => ({
                          id: e.id,
                          label: e.tag,
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.storeTag && (
                      <>
                        {errors.storeTag.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                    <Tooltip text={translator("PosTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="posTag"
                      onChange={function (event) {
                        setValue("partners", null);
                        setValue("users", null);
                        setSearch({
                          ...search,
                          posTag: event[0].value,
                          partnerGuid: "",
                          userGuid: "",
                        });
                        setReportTag({
                          ...reportTag,
                          posName: event[0].value,
                        });
                        //setReports([]);
                        return event[0];
                      }}
                      options={
                        posTag &&
                        posTag.map((e) => ({
                          id: e.posid,
                          label: e.tag + " - ( " + e.inventoryNumber + " )",
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.posTag && (
                      <>
                        {errors.posTag.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("Report-Partners")}</label>
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="partners"
                      onChange={function (event) {
                        setValue("users", null);
                        setSearch({
                          ...search,
                          partnerGuid: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          partnerName: event[0].label,
                        });
                        //setReports([]);
                        return event[0];
                      }}
                      options={
                        tenantPartners &&
                        tenantPartners.map((e) => ({
                          id: e.id,
                          label: e.name,
                          value: e.name,
                        }))
                      }
                    />
                  </div>
                </>
              }
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("Report-Users")}</label>
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="userGuid"
                      onChange={function (event) {
                        setSearch({
                          ...search,
                          userGuid: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          userName: event[0].label,
                        });
                        //setReports([]);
                        return event[0];
                      }}
                      options={
                        users &&
                        users.map((e) => ({
                          id: e.userId,
                          label: e.realName,
                          value: e.realName,
                        }))
                      }
                    />
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidFrom")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        maxDate={
                          search && search.validTo && new Date(search.validTo)
                        }
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="validFrom"
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        rules={{ required: true }}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "validFrom",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setValue("validTo", null);
                          setReportTag({
                            ...reportTag,
                            dateFrom: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.validFrom &&
                      errors.validFrom.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidTo")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        disabled={search && search.validFrom ? false : true}
                        as={DatePicker}
                        minDate={
                          search &&
                          search.validFrom &&
                          new Date(search.validFrom)
                        }
                        maxDate={
                          search &&
                          search.validFrom &&
                          new Date(
                            new Date(search.validFrom).getFullYear(),
                            11,
                            31
                          )
                        }
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="validTo"
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "validTo",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            dateTo: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.validTo && errors.validTo.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <>
              <div className="btn-group col-md-1">
                <button
                  type="button"
                  className="btn btn-outline-secondary dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Izvezi u
                </button>
                <div className="dropdown-menu">
                  <a className="dropdown-item" onClick={exportFunction}>
                    .PDF
                  </a>
                  <a className="dropdown-item" onClick={exportExcelFunction}>
                    .XLSX
                  </a>
                  <a
                    className="dropdown-item"
                    onClick={exportOverviewTotalExcelFunction}
                  >
                    {translator("OverviewTotal")}
                  </a>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <Modal
            scrollable={true}
            show={showInvoiceDetails}
            onHide={() => setShowInvoiceDetails(false)}
            //backdrop="static"
            keyboard={true}
            centered
          >
            <Modal.Header>
              <Modal.Title>{translator("Reports-InvoiceDetails")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                }}
              >
                <strong>
                  {" "}
                  <span style={{ fontSize: 19 }}>
                    {invoiceDetails.tenantName}
                  </span>
                </strong>
                <br />
                <br />
                {invoiceDetails.address}
                <br />
                {invoiceDetails.tenantCity}
                <br />
                OIB: {invoiceDetails.tenantOib}
                <hr style={{ border: "1px dashed lightgrey" }} />
                {invoiceDetails.storeName}
                <br />
                {invoiceDetails.storeAddress}
                <br />
                {invoiceDetails.storeCity &&
                  invoiceDetails.storeCity.replace(/,/g, ", ")}
              </div>
              {invoiceDetails.partnerGuid && (
                <>
                  <hr style={{ border: "1px dashed lightgrey" }} />
                  {"Partner:"}
                  <br />
                  {invoiceDetails.partnerName}
                  <br />
                  OIB: {invoiceDetails.partnerOib}
                  <br />
                  {invoiceDetails.partnerAddress}
                  <br />
                  {invoiceDetails.partnerCity}
                  <br />
                </>
              )}
              <hr style={{ border: "1px dashed lightgrey" }} />
              <span>
                <span style={{ textAlign: "left" }}>Datum računa:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.issued &&
                    new Intl.DateTimeFormat("hr", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: false,
                      timeZone: "Europe/Zagreb",
                    })
                      .format(new Date(invoiceDetails.issued))
                      .replace(/\s/g, "")
                      .substr(0, 10)}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Vrijeme izdavanja:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.issued &&
                    new Intl.DateTimeFormat("hr", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: false,
                      timeZone: "Europe/Zagreb",
                    })
                      .format(new Date(invoiceDetails.issued))
                      .replace(/\s/g, "")
                      .substr(11, 19)}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Način plaćanja:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetailsPayments &&
                  invoiceDetailsPayments.reduce(function (a, b) {
                    return Number(a) + Number(b.paidValue);
                  }, 0) > 0 ? (
                    invoiceDetailsPayments.filter(
                      (e) => Number(e.paidValue) > 0
                    )[0].paymentMethodName
                  ) : (
                    <>
                      {" "}
                      <span> {invoiceDetails.paymentMethodName}</span> /{" "}
                      <span style={{ color: "red" }}>Storno</span>
                    </>
                  )}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Operater:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.userPrintName}
                </span>
              </span>
              <br />
              <br />
              <span style={{ fontSize: 19 }}>
                {" "}
                <span style={{ textAlign: "left" }}>
                  Račun: {invoiceDetails.documentNumber}/{""}
                  {invoiceDetails.storeTag}/{invoiceDetails.posTag}
                </span>
              </span>
              <br />
              <hr style={{ border: "1px dashed lightgrey" }} />
              <table style={{ width: "100%", fontSize: "16px" }}>
                <thead>
                  <tr>
                    <th>Naziv</th>
                    <th>Cijena</th>
                    <th>Kol.</th>
                    <th style={{ float: "right" }}>Iznos</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceDetailsItems &&
                    invoiceDetailsItems.map((item) => {
                      return (
                        <>
                          <tr>
                            <td>{item.productName}</td>
                            <td>
                              {new Intl.NumberFormat("hr-HR", {
                                minimumFractionDigits: 2,
                              }).format(item.price)}
                            </td>
                            <td>
                              {item.quantity} {item.unitOfMeasureName}
                            </td>
                            <td style={{ float: "right" }}>
                              {new Intl.NumberFormat("hr-HR", {
                                minimumFractionDigits: 2,
                              }).format(item.totalValue)}
                            </td>
                          </tr>
                          {item.discount > 0 ? (
                            <tr>
                              <td></td>
                              <td>popust:</td>
                              <td>{item.discount}%</td>
                              <td style={{ float: "right" }}>
                                {new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.discountValue)}
                              </td>
                            </tr>
                          ) : null}
                        </>
                      );
                    })}
                </tbody>
              </table>
              <hr style={{ border: "1px dashed lightgrey" }} />
              <>
                {invoiceDetailsItems.reduce(function (a, b) {
                  return Number(a) + Number(b.discountValue);
                }, 0) > 0 ? (
                  <>
                    <span style={{ float: "left" }}>Ukupno : </span>{" "}
                    <span style={{ float: "right" }}>
                      {invoiceDetailsItems &&
                        currencyFormatter(
                          invoiceDetailsItems.reduce(function (a, b) {
                            return Number(a) + Number(b.totalValue);
                          }, 0)
                        )}
                    </span>
                    <br />
                    <span style={{ float: "left" }}>Popust : </span>{" "}
                    <span style={{ float: "right" }}>
                      {invoiceDetailsItems &&
                        currencyFormatter(
                          invoiceDetailsItems.reduce(function (a, b) {
                            return Number(a) + Number(b.discountValue);
                          }, 0)
                        )}
                    </span>
                    <br />
                  </>
                ) : null}
              </>
              <span style={{ float: "left", marginTop: "10px" }}>
                ZA PLATITI:{" "}
              </span>{" "}
              <span
                style={{
                  float: "right",
                  marginTop: "10px",
                }}
              >
                {/* {invoiceDetailsPayments &&
                  currencyFormatter(
                    invoiceDetailsPayments.reduce(function (a, b) {
                      return Number(a) + Number(b.paidValue);
                    }, 0)
                  )} */}
                {invoiceDetails && currencyFormatter(invoiceDetails.payValue)}
              </span>
              <br />
              <hr style={{ border: "1px dashed lightgrey" }} />
              <table style={{ width: "100%", fontSize: "16px" }}>
                <thead>
                  <tr>
                    <th>Stopa(%)</th>
                    <th>Osnovica</th>
                    <th style={{ float: "right" }}>Iznos</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceDetailsTaxes &&
                    invoiceDetailsTaxes
                      .filter((x) => x.taxRateId != null)
                      .map((item) => {
                        return (
                          <>
                            <tr>
                              <td>
                                {item.taxRateId != null ? "PDV" : "PP"} :{" "}
                                {item.taxRateId != null
                                  ? item.taxRate
                                  : item.pp}
                              </td>
                              <td>
                                {new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.groupNetValue)}
                              </td>
                              <td style={{ float: "right" }}>
                                {item.taxRateId != null
                                  ? new Intl.NumberFormat("hr-HR", {
                                      minimumFractionDigits: 2,
                                    }).format(item.groupTaxValue)
                                  : new Intl.NumberFormat("hr-HR", {
                                      minimumFractionDigits: 2,
                                    }).format(item.groupPpvalue)}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                  {invoiceDetailsItems &&
                  invoiceDetailsItems
                    .filter((e) => e.taxRateId === 0)
                    .reduce(function (a, b) {
                      return Number(a) + Number(b.totalValue);
                    }, 0) > 0 ? (
                    <>
                      <tr>
                        <td>Bez poreza</td>
                        <td></td>
                        <td style={{ float: "right" }}>
                          {invoiceDetailsItems &&
                            currencyFormatter(
                              invoiceDetailsItems
                                .filter((e) => e.taxRateId === 0)
                                .reduce(function (a, b) {
                                  return Number(a) + Number(b.totalValue);
                                }, 0)
                            )}
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                  {invoiceDetailsTaxes &&
                    invoiceDetailsTaxes
                      .filter((x) => x.taxRateId === null)
                      .map((item) => {
                        return (
                          <>
                            <tr>
                              <td>
                                {item.taxRateId != null ? "PDV" : "PP"} :{" "}
                                {item.taxRateId != null
                                  ? item.taxRate
                                  : item.pp}
                              </td>
                              <td>
                                {new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.groupNetValue)}
                              </td>
                              <td style={{ float: "right" }}>
                                {item.taxRateId != null
                                  ? new Intl.NumberFormat("hr-HR", {
                                      minimumFractionDigits: 2,
                                    }).format(item.groupTaxValue)
                                  : new Intl.NumberFormat("hr-HR", {
                                      minimumFractionDigits: 2,
                                    }).format(item.groupPpvalue)}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                </tbody>
              </table>
              <hr style={{ border: "1px dashed lightgrey" }} />
              {invoiceDetailsItems &&
              invoiceDetailsItems.reduce(function (a, b) {
                return Number(a) + Number(b.pn) * b.quantity;
              }, 0) > 0 ? (
                <>
                  {" "}
                  <span style={{ textAlign: "left" }}>Povratna naknada :</span>
                  <span style={{ float: "right" }}>
                    {invoiceDetailsItems &&
                      currencyFormatter(
                        invoiceDetailsItems.reduce(function (a, b) {
                          return Number(a) + Number(b.pn) * b.quantity;
                        }, 0)
                      )}
                  </span>
                  <hr style={{ border: "1px dashed lightgrey" }} />
                </>
              ) : (
                ""
              )}
              <div
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  marginTop: "15px",
                }}
              >
                {paymentId == 4 && year.getFullYear() < 2026 ? null : (
                  <>
                    ZKI: {invoiceDetails.zki}
                    <br />
                    JIR: {invoiceDetails.jir}
                    <br />
                  </>
                )}

                {invoiceDetails.taxNote && invoiceDetailsTaxes.length === 0
                  ? `Porezna bilješka: ${invoiceDetails.taxNote}`
                  : ""}
              </div>
              <hr style={{ border: "1px dashed lightgrey" }} />
              {paymentId == 4 && year.getFullYear() < 2026
                ? null
                : qrcodeText !== "" && (
                    <div style={{ textAlign: "center" }}>
                      <QRCode id="qrCode" size={120} value={qrcodeText} />
                      <div>{invoiceDetails.footerNote}</div>
                    </div>
                  )}
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={exportToPdf}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {/*invoiceDetails.partnerGuid && 1==2 && (
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={sendPdfToMail}
                >
                  <i className="fas fa-file-pdf"></i>{" "}
                  {translator("Reports-Pdf")}
                </button>
              )*/}

              {invoiceDetails.partnerGuid && (
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={sendPdfToPartnerMail}
                >
                  <i className="fas fa-file-pdf"></i>{" "}
                  {translator("Send-Partner-Pdf")}
                </button>
              )}

              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={openSendMailModal}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Send-Mail-Pdf")}
              </button>

              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowInvoiceDetails(false)}
              >
                {translator("General-Close")}
              </button>

              {[master].includes(Number(roleId)) && !invoiceDetails?.jir && (
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => fiscal(invoiceDetails.invoiceGuid)}
                >
                  {translator("Fiskaliziraj")}
                </button>
              )}

              {invoiceDetails?.isEdi && (
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowEdiFiscalModal(true)}
                >
                  {translator("BtnSend-Banquap-Fiscal")}
                </button>
              )}
            </Modal.Footer>
            <EmailModal
            invoiceDetails={invoiceDetails}
            invoiceDetailsItems={invoiceDetailsItems}
            invoiceDetailsPayments={invoiceDetailsPayments}
            invoiceDetailsTaxes={invoiceDetailsTaxes}
            base64QR={qrCodeGen}
              show={sendPdfToMailOpenModal}
              handleHide={() => {
                setUpdate(new Date());
                setSendPdfToMailOpenModal(false);
              }}
            />
            <EdiFiscalModal
              show={showEdiFiscalModal}
              handleHide={() => setShowEdiFiscalModal(false)}
              title={translator("EdiFiscalModal-Title")}
              text={translator("EdiFiscalModal-Text")}
              confirmEdiFiscal={() => ediFiscal(invoiceDetails.invoiceGuid)}
            />
            <ResultModal
              show={ediFiscalResultModal.show}
              title={ediFiscalResultModal.title}
              text={ediFiscalResultModal.text}
              btnClass={ediFiscalResultModal.btnClass}
              handleClose={() =>
                setEdiFiscalResultModal({ ...ediFiscalResultModal, show: false })
              }
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Table;
